import { render, staticRenderFns } from "./booklist.vue?vue&type=template&id=432faf41&scoped=true&"
import script from "./booklist.vue?vue&type=script&lang=js&"
export * from "./booklist.vue?vue&type=script&lang=js&"
import style0 from "./booklist.vue?vue&type=style&index=0&id=432faf41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432faf41",
  null
  
)

component.options.__file = "booklist.vue"
export default component.exports